export default {
    methods: {
        supplierNav() {
            window.$(document).ready(function() {
                var $navLink = window.$('.supplier-nav__link')
                $navLink.on('click', function() {
                    var id = window.$(this).data('target')

                    if (window.$(window).width() > max_screen_sm) {
                        window
                            .$('#supplier-cabinet-header-d')
                            .removeClass('hide')
                        window.$('#supplier-cabinet-header-m').addClass('hide')

                        $navLink.removeClass('active')
                        window.$(this).addClass('active')
                    } else {
                        window.$('#supplier-cabinet-header-d').addClass('hide')
                        window
                            .$('#supplier-cabinet-header-m')
                            .removeClass('hide')
                        window
                            .$('#supplier-cabinet-title')
                            .html(window.$('#' + id).data('title'))
                        window.$('.supplier-nav').addClass('hide')
                    }

                    window.$('.supplier-tab').fadeOut(200)
                    setTimeout(function() {
                        window.$('#' + id).fadeIn(200)
                    }, 300)
                })

                window.$('#supplier-cabinet-back').on('click', function() {
                    //показать основной header
                    window.$('#supplier-cabinet-header-d').removeClass('hide')
                    window.$('#supplier-cabinet-header-m').addClass('hide')

                    window.$('.supplier-tab').fadeOut(200)
                    setTimeout(function() {
                        window.$('.supplier-nav').removeClass('hide')
                    }, 300)
                })

                window
                    .$('#supplier-cabinet-back-brands')
                    .on('click', function() {
                        //показать основной header
                        window
                            .$('#supplier-cabinet-header-m')
                            .removeClass('hide')
                        window
                            .$('#supplier-cabinet-header-brands-m')
                            .addClass('hide')

                        // window.$('.cabinet-settings-brands__tab').fadeOut(100)
                        setTimeout(function() {
                            window
                                .$('.cabinet-settings-brands__sidebar')
                                .removeClass('hide')
                        }, 300)
                    })

                var showFirstTab = debounce(function($link, $tab) {
                    if (
                        window.$(window).width() > max_screen_sm &&
                        $link.length
                    ) {
                        $link[0].click()
                    } else {
                        $tab.fadeOut(200)
                    }
                }, 250)

                showFirstTab($navLink, window.$('.supplier-tab'))
                // setTimeout(function() {
                //     showFirstTab(
                //         $brandsNavLink,
                //         window.$('.cabinet-settings-brands__tab')
                //     )
                // }, 300)

                var width = window.$(window).width()
                window.$(window).on('resize', function() {
                    //bind only width change
                    if (window.$(window).width() == width) return

                    width = window.$(window).width()

                    window.$('.supplier-nav').removeClass('hide')
                    window
                        .$('.cabinet-settings-brands__sidebar')
                        .removeClass('hide')
                    window
                        .$('#supplier-cabinet-header-brands-m')
                        .addClass('hide')

                    showFirstTab($navLink, window.$('.supplier-tab'))
                    // setTimeout(function() {
                    //     showFirstTab(
                    //         $brandsNavLink,
                    //         window.$('.cabinet-settings-brands__tab')
                    //     )
                    // }, 300)
                })
            })

            var max_screen_sm = 767

            function debounce(func, wait, immediate) {
                var timeout
                return function() {
                    var context = this,
                        args = arguments
                    var later = function() {
                        timeout = null
                        if (!immediate) func.apply(context, args)
                    }
                    var callNow = immediate && !timeout
                    clearTimeout(timeout)
                    timeout = setTimeout(later, wait)
                    if (callNow) func.apply(context, args)
                }
            }
        }
    }
}
